import { ReactNode } from "react"

interface CampaignFormHeaderButtonProps {
  children: ReactNode
  onClick: () => void
}

const CampaignFormHeaderButton = ({ children, onClick }: CampaignFormHeaderButtonProps) => {
  return (
    <button
      className="block mx-auto mt-[40px] px-3 py-1 underline underline-offset-2 text-[15px]"
      type="button"
      onClick={onClick}
    >
      {children}
    </button>
  )
}

export default CampaignFormHeaderButton
